import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import Add from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import { Map as GoogleMap, MapMouseEvent, useMap } from '@vis.gl/react-google-maps';
import React from 'react';
import { useSelector } from 'react-redux';
import classifyPoint from 'robust-point-in-polygon';
import { hasErrors } from '../../../common/enums';
import { PolygonCoords } from '../../../common/enums/maps';
import { newZone, Zones } from '../../../common/models/zones';
import { googleMapSlice } from '../../../common/store/googleMapSlice';
import { AppState, appStore, franchiseSelector, zoneSelector } from '../../../common/store/store';
import { zoneSlice } from '../../../common/store/zoneSlice';
import { deleteData, postData } from '../../api';
// https://developers.google.com/maps/documentation/javascript/examples/polygon-simple?_gl=1*15eo889*_up*MQ..*_ga*NTE4Mzk2NjYzLjE3NDczMTAwNzc.*_ga_NRWSTWS78N*czE3NDczMTAwNzYkbzEkZzEkdDE3NDczMTExODQkajAkbDAkaDA.
// https://developers.google.com/maps/documentation/javascript/examples/drawing-tools?_gl=1*3pylu0*_up*MQ..*_ga*MTY4NjgwNTA5MS4xNzQ3MzExNTMw*_ga_NRWSTWS78N*czE3NDczMTE1MjkkbzEkZzEkdDE3NDczMTE1MzAkajAkbDAkaDA.

let newPolygon: google.maps.Polygon | undefined = undefined;


let newPolygonCallback: (polygon: google.maps.Polygon) => Promise<void>;

export const ZoneMap = () => {
    console.log('ZONE MAP EXECUTED');
    const map = useMap();

    const mapOk = Boolean(map);

    const [initialised, setInitialized] = React.useState(false);
    const zones = useSelector((state: AppState) => zoneSelector.selectAll(state));
    const [currentPolygons, setCurrentPolygons] = React.useState<{ poly: google.maps.Polygon, zoneId: ModelId; }[]>([]);
    const [drawingManager, setDrawingManager] = React.useState<google.maps.drawing.DrawingManager | undefined>();
    const [createZoneMode, setCreateZoneMode] = React.useState<boolean>(false);
    const selectedZone = useSelector((state: AppState) => zoneSelector.selectById(state, state.googleMap.selectedZone ?? -1));
    const newPolygonInc = useSelector((state: AppState) => state.googleMap.newPolygon);

    const franchises = useSelector((state: AppState) => franchiseSelector.selectAll(state));
    const selectedFranchise = useSelector((state: AppState) => state.googleMap.franchiseId);

    React.useEffect(() => {
        if (mapOk) {
            setDrawingManager(new google.maps.drawing.DrawingManager({
                drawingMode: null,
                drawingControl: false,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [
                        google.maps.drawing.OverlayType.POLYGON,
                    ],
                },
                polygonOptions: {
                    editable: true,
                }
            }));
        }
    }, [mapOk]);

    React.useEffect(() => {
        if (drawingManager) {

            drawingManager.setMap(map);

            google.maps.event.addListener(drawingManager, 'overlaycomplete', (event: google.maps.drawing.OverlayCompleteEvent) => {
                // since this is a glboal function, we totally lose our scope (WHY THA HELL)


                if (event.overlay instanceof google.maps.Polygon) {
                    // do stuff
                    newPolygonCallback(event.overlay);
                }
            });


            zones.map(createZonePolygon);

            setInitialized(true);
        }
    }, [drawingManager]);

    const createZonePolygon = (zone: Zones) => {
        // craete the polygon
        const polygon = new google.maps.Polygon({
            editable: false,
            map: map,
            paths: zone.paths
        });

        setCurrentPolygons(p => p.concat([{ poly: polygon, zoneId: zone.id }]));
    };

    React.useEffect(() => {
        if (initialised) {
            zones.forEach(zone => {
                if (!currentPolygons.find(p => p.zoneId === zone.id)) {
                    createZonePolygon(zone);
                }
            });
        }
    }, [zones, initialised]);

    React.useEffect(() => {

        if (newPolygon) {
            //const paths = newPolygon.getPath().getArray().map(p => p.toJSON());
            newPolygon.setMap(null);
            newPolygon = undefined;
        }
    }, [newPolygonInc]);

    const onNewPolygon = async (polygon: google.maps.Polygon) => {

        console.log('Polygon createion. franchise selected', selectedFranchise, currentPolygons);
        setCreateZoneMode(false);

        const zone: Zones = {
            ...newZone,
            id: crypto.randomUUID().toString(),
            paths: polygon.getPath().getArray().map(p => p.toJSON()),
            franchiseId: selectedFranchise ?? null
        };

        const { paths } = corrigerPaths(zones, polygon.getPath().getArray().map(p => p.toJSON()));
        zone.paths = paths;
        const response = await postData<Zones>('zones', zone);
        drawingManager?.setDrawingMode(null);
        if (!hasErrors(response)) {
            appStore.dispatch(zoneSlice.actions.addOne(response));
            // delete polygon since component will automatically crtaete it
            polygon.setMap(null);
            /*
            setCurrentPolygons(p => {
                return p.concat([{ poly: polygon, zoneId: response.id }]);
            });
            */
            appStore.dispatch(googleMapSlice.actions.selectZone(response.id));
        }
    };

    newPolygonCallback = onNewPolygon;

    const onFranchiseSelected = async (franchiseId: ModelId) => {
        appStore.dispatch(googleMapSlice.actions.setFranchise(franchiseId));
        if (selectedZone && selectedZone?.franchiseId !== franchiseId) {
            appStore.dispatch(zoneSlice.actions.updateOne({ id: selectedZone.id, changes: { franchiseId } }));
            await postData<Zones>('zones', { id: selectedZone.id, franchiseId });
        }
    };

    const onMapClick = (event: MapMouseEvent) => {
        console.log('Map click', event);
        appStore.dispatch(googleMapSlice.actions.selectZone(null));
    };

    const fixPolygon = (paths: PolygonCoords[], poly: google.maps.Polygon, zoneId: ModelId) => {
        // on doit le recréer
        poly.setMap(null);
        const polygon = new google.maps.Polygon({
            editable: true,
            map: map,
            paths: paths
        });
        setCurrentPolygons(p => {
            const r = p.filter(p => p.zoneId != zoneId);
            return r.concat([{ poly: polygon, zoneId: zoneId }]);
        });

    };

    const onCreateButtonClick = () => {
        if (createZoneMode) {
            drawingManager?.setDrawingMode(null);
            setCreateZoneMode(false);
        } else {
            appStore.dispatch(googleMapSlice.actions.selectZone(null));
            drawingManager?.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            setCreateZoneMode(true);
        }
    };

    const onDeleteClick = async () => {
        if (selectedZone) {
            const item = currentPolygons.find(p => p.zoneId == selectedZone.id);
            setCurrentPolygons(p => p.filter(q => q.zoneId != selectedZone.id));
            item?.poly.setMap(null);
            const response = await deleteData('zones', selectedZone.id);
            if (!hasErrors(response)) {
                appStore.dispatch(zoneSlice.actions.removeOne(selectedZone.id));
            }

        }
    };

    return <><Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flex: 1, display: 'flex', gap: 2, p: 2 }}>
            <ButtonGroup>
                {franchises.map(p => {
                    return <Button variant={selectedFranchise === p.id ? 'contained' : 'outlined'} onClick={() => { onFranchiseSelected(p.id); }} key={p.id}>
                        <Chip size='small' label=" " sx={{ backgroundColor: p.color, m: 1 }} />{p.code}
                    </Button>;
                })}
            </ButtonGroup>
            <ButtonGroup>
                <Button variant='outlined' onClick={onCreateButtonClick}>{createZoneMode ? <>Annuler</> : <><Add /> Créer</>}</Button>
                <Tooltip title='Doubler cliquer pour supprimer'>
                    <Button variant='outlined' disabled={selectedZone == null} onDoubleClick={onDeleteClick}><Delete /> Supprimer</Button>
                </Tooltip>
            </ButtonGroup>
        </Box>
        <Box sx={{ height: '400px' }}>
            <GoogleMap
                defaultBounds={{
                    "south": 44.866238944444,
                    "west": -80.03766718924243,
                    "north": 47.89669085086322,
                    "east": -62.38263789236743
                }}
                onClick={onMapClick}
                defaultZoom={7} />
        </Box>
    </Box>
        {map ? currentPolygons.map((p, index) => <Zone map={map} zoneId={p.zoneId} key={p.zoneId} polygon={p.poly} fixPolygon={fixPolygon} />) : null}
    </>;
};

const Zone = (props: { map: google.maps.Map, zoneId: ModelId, polygon: google.maps.Polygon, fixPolygon: (paths: PolygonCoords[], polygon: google.maps.Polygon, zoneId: ModelId) => void; }) => {

    const zone = useSelector((state: AppState) => zoneSelector.selectById(state, props.zoneId));
    const selectedZone = useSelector((state: AppState) => state.googleMap.selectedZone);
    const relatedFranchise = useSelector((state: AppState) => franchiseSelector.selectById(state, zone?.franchiseId ?? 0));
    const zones = useSelector((state: AppState) => zoneSelector.selectAll(state));

    const updateModel = async (data: Partial<Zones>) => {
        if (zone) {
            const response = await postData<Zones>('zones', { id: props.zoneId, ...data });
            if (!hasErrors(response)) {
                appStore.dispatch(zoneSlice.actions.updateOne({ id: props.zoneId, changes: response }));
            }
        }
    };

    React.useEffect(() => {

        props.polygon.setOptions({
            editable: zone && selectedZone === zone.id,
            strokeColor: (zone && selectedZone === zone.id) ? "#0059ff" : null,
            strokeOpacity: (zone && selectedZone === zone.id) ? 1 : 0.2
        }
        );

    }, [selectedZone, props.polygon]);


    const onPolygonEdited = (_index: number, _obj: any) => {
        if (props.polygon && zone) {
            const { fixed, paths } = corrigerPaths(zones, props.polygon.getPath().getArray().map(p => p.toJSON()), zone.id);
            updateModel({ paths: paths });
            if (fixed) {
                props.fixPolygon(paths, props.polygon, zone.id);
            }
        }
    };

    const onPolygonSelected = () => {
        zone && appStore.dispatch(googleMapSlice.actions.selectZone(zone.id));
        zone && appStore.dispatch(googleMapSlice.actions.setFranchise(zone.franchiseId ?? undefined));
    };



    React.useEffect(() => {
        if (props.polygon && zone) {
            const a = JSON.stringify(props.polygon.getPath().getArray().map(p => p.toJSON()));
            const b = JSON.stringify(zone.paths);
            if (a != b) {
                props.fixPolygon(zone.paths, props.polygon, props.zoneId);
            }


        }
    }, [zone]);

    React.useEffect(() => {
        props.polygon.setOptions({
            fillColor: relatedFranchise?.color ?? '#000',
        });
    }, [relatedFranchise, props.polygon]);


    React.useEffect(() => {
        console.log('LISTEN TO POLYGON');
        listenToPolygon();
    }, [props.polygon]);

    const listenToPolygon = () => {
        google.maps.event.addListener(props.polygon.getPath(), 'insert_at', onPolygonEdited);
        google.maps.event.addListener(props.polygon.getPath(), 'set_at', onPolygonEdited);
        google.maps.event.addListener(props.polygon, 'click', onPolygonSelected);
    };

    return <></>;
};

const corrigerPaths = (zones: Zones[], paths: PolygonCoords[], zoneId?: ModelId) => {
    let currentZonePath: PolygonCoords[] = [...paths];
    let fixed: boolean = false;
    for (let p of zones) {
        console.log('p', p);
        if (p.id !== zoneId && p.paths && p.paths.length) {

            // vérifier
            currentZonePath = currentZonePath.map(coord => {
                if (classifyPoint(p.paths.map(q => [q.lat, q.lng]), [coord.lat, coord.lng]) == -1) {
                    //if (isPointInPolygon(coord, p.paths)) {
                    fixed = true;
                    // on corrige le point, on le ramène au point le plus près !
                    const result = p.paths.reduce((acc: { dist: number, closest: PolygonCoords; }, closest: PolygonCoords, _index: number) => {
                        var dist = Math.sqrt(Math.pow((coord.lng - closest.lng), 2) + Math.pow((coord.lat - closest.lat), 2));
                        if (dist < acc.dist) {
                            return { dist, closest };
                        } else return acc;
                    }, { dist: Number.MAX_SAFE_INTEGER, closest: coord });
                    return result.closest;
                } else {
                    return coord;
                }
            });

        }
    }
    return { fixed, paths: fixed ? currentZonePath : paths };
};
